/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateExerciseLanguageDto } from './create-exercise-language-dto';
import { CreateExerciseSourceDto } from './create-exercise-source-dto';
import { CreateExerciseToolDto } from './create-exercise-tool-dto';
import { EnExerciseStatus } from './en-exercise-status';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface UpdateExerciseDto
 */
export interface UpdateExerciseDto {

    /**
     * @type {string}
     * @memberof UpdateExerciseDto
     */
    name?: string;

    /**
     * @type {string}
     * @memberof UpdateExerciseDto
     */
    orientation?: UpdateExerciseDtoOrientationEnum;

    /**
     * @type {string}
     * @memberof UpdateExerciseDto
     */
    side?: UpdateExerciseDtoSideEnum;

    /**
     * @type {string}
     * @memberof UpdateExerciseDto
     */
    position?: UpdateExerciseDtoPositionEnum;

    /**
     * @type {string}
     * @memberof UpdateExerciseDto
     */
    direction?: UpdateExerciseDtoDirectionEnum;

    /**
     * @type {number}
     * @memberof UpdateExerciseDto
     */
    rotation?: number;

    /**
     * @type {number}
     * @memberof UpdateExerciseDto
     */
    duration?: number;

    /**
     * @type {boolean}
     * @memberof UpdateExerciseDto
     */
    isStatic?: boolean;

    /**
     * @type {EnExerciseStatus}
     * @memberof UpdateExerciseDto
     */
    status?: EnExerciseStatus;

    /**
     * @type {string}
     * @memberof UpdateExerciseDto
     */
    note?: string;

    /**
     * @type {Array<CreateExerciseSourceDto | JoinEntityDto>}
     * @memberof UpdateExerciseDto
     */
    sources?: Array<CreateExerciseSourceDto | JoinEntityDto>;

    /**
     * @type {Array<CreateExerciseToolDto | JoinEntityDto>}
     * @memberof UpdateExerciseDto
     */
    tools?: Array<CreateExerciseToolDto | JoinEntityDto>;

    /**
     * @type {Array<CreateExerciseLanguageDto | JoinEntityDto>}
     * @memberof UpdateExerciseDto
     */
    languages?: Array<CreateExerciseLanguageDto | JoinEntityDto>;

    /**
     * @type {Array<JoinEntityDto>}
     * @memberof UpdateExerciseDto
     */
    tags?: Array<JoinEntityDto>;
}

/**
 * @export
 * @enum {string}
 */
export enum UpdateExerciseDtoOrientationEnum {
    VERTICAL = 'VERTICAL',
    HORIZONTAL = 'HORIZONTAL'
}
/**
 * @export
 * @enum {string}
 */
export enum UpdateExerciseDtoSideEnum {
    LEFT = 'LEFT',
    RIGHT = 'RIGHT'
}
/**
 * @export
 * @enum {string}
 */
export enum UpdateExerciseDtoPositionEnum {
    STANDING = 'STANDING',
    SEATED = 'SEATED',
    PRONE = 'PRONE',
    SUPINE = 'SUPINE',
    KNEELING = 'KNEELING'
}
/**
 * @export
 * @enum {string}
 */
export enum UpdateExerciseDtoDirectionEnum {
    FRONTAL = 'FRONTAL',
    LATERAL = 'LATERAL',
    BEHIND = 'BEHIND'
}

